import axios from './_nestAxios'

export const obtenerxIdAsEdicion = _id => axios.get(`/categorias/${_id}`)
export const obtenerAsSelect = () => axios.get('/categorias', { params: { tipoConsulta: 'select' } })

export const nuevo = data => axios.post('/categorias', data)

export const actualizarxId = (_id, data) => axios.put(`/categorias/${_id}`, data)

export const eliminarxId = _id => axios.delete(`/categorias/${_id}`)

// 🔎 Nuevo: búsqueda de categorías para autocompletar
export const obtenerCategoriasxBusquedaAsSelect2 = (idCompania, busqueda) => {
  const filtros = { _idCompania: idCompania }

  if (busqueda) {
    filtros.busqueda = busqueda
  }

  return axios.get('/categorias', {
    params: {
      tipoConsulta: 'select2-categorias',
      ...filtros
    }
  })
}